var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconStopSign(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8f6fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#efdcfb"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 225.211,
    x2: 280.219,
    xlinkHref: "#lg1",
    y1: 441.971,
    y2: 441.971
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 267.088,
    x2: 247.755,
    y1: 434.208,
    y2: 349.542
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efdcfb",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4856,
    stopColor: "#baaad6",
    stopOpacity: 0.486
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8679b2"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 132,
    x2: 374.513,
    y1: 71.299,
    y2: 313.812
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f82814"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0272d"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 258.237,
    x2: 90.334,
    xlinkHref: "#lg2",
    y1: 310.324,
    y2: 142.42
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 323.691,
    x2: 166.448,
    xlinkHref: "#lg2",
    y1: 291.749,
    y2: 134.506
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 373.21,
    x2: 261.303,
    xlinkHref: "#lg2",
    y1: 279.643,
    y2: 167.736
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 418.76,
    x2: 327.643,
    xlinkHref: "#lg2",
    y1: 250.002,
    y2: 158.885
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 137.438,
    x2: 146.438,
    xlinkHref: "#lg1",
    y1: 156.377,
    y2: 292.87
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 213.505,
    x2: 222.505,
    xlinkHref: "#lg1",
    y1: 151.362,
    y2: 287.855
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 284.874,
    x2: 293.874,
    xlinkHref: "#lg1",
    y1: 146.656,
    y2: 283.149
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 364.135,
    x2: 373.135,
    xlinkHref: "#lg1",
    y1: 141.43,
    y2: 277.923
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg2",
    y1: 349.299,
    y2: 384.313
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m266.252 510h-22.505c-14.314 0-25.917-11.604-25.917-25.917v-110.14h74.34v110.14c0 14.313-11.604 25.917-25.918 25.917z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m217.83 388.599 74.34 74.34v-88.996h-74.34z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m348.168 0h-186.336c-11.764 0-22.634 6.276-28.516 16.464l-93.168 161.371c-5.882 10.188-5.882 22.74 0 32.928l93.168 161.372c5.882 10.188 16.752 16.464 28.516 16.464h186.336c11.764 0 22.634-6.276 28.516-16.464l93.168-161.372c5.882-10.188 5.882-22.74 0-32.928l-93.168-161.371c-5.882-10.188-16.752-16.464-28.516-16.464z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m332.04 363.964h-154.08c-12.9 0-24.923-6.94-31.374-18.113l-77.04-133.438c-6.45-11.173-6.45-25.054-.001-36.227l77.041-133.438c6.451-11.173 18.474-18.114 31.374-18.114h154.08c12.9 0 24.923 6.94 31.374 18.113l77.04 133.438c6.45 11.173 6.45 25.054.001 36.227l-77.041 133.438c-6.451 11.174-18.474 18.114-31.374 18.114zm-154.08-321.33c-6.491 0-12.54 3.492-15.786 9.114l-77.04 133.437c-3.245 5.622-3.245 12.606 0 18.228l77.04 133.437c3.246 5.622 9.295 9.114 15.786 9.114h154.08c6.491 0 12.54-3.492 15.786-9.114l77.04-133.437c3.245-5.622 3.245-12.606 0-18.228l-77.04-133.437c-3.246-5.622-9.295-9.114-15.786-9.114z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m381.65 363.519-4.97 8.62c-4.92 8.52-13.33 14.3-22.84 15.97-1.85.32-3.75.49-5.67.49h-82.39l-151.24-151.24c-4.16-2.98-4.67-6.59-4.67-10.24 0-4.58 2.05-9.32 7.17-9.32 6.33 0 10.38 9.97 22.91 9.97 3.69 0 7.61-2.87 10.19-4.92l-29.47-29.49c-5.97-4.81-8.37-11.39-8.37-21.5 0-20.22 15.66-25.9 32.51-25.9 6.43 0 23-.91 26.25 6.97l32.11 32.11z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m411.16 312.409-.58 1.01-25.38 43.95-3.55 6.15-4.97 8.62c-4.92 8.52-13.33 14.3-22.84 15.97l-145.69-145.69c-2.87-1-4.98-2.87-4.98-5.59v-53.61l-19.32-19.63c-3.59-.5-3.61-4.71-3.61-9.52 0-4.45-.12-7.31 4.33-7.31h58.23c2.99 0 4.82.2 5.7 2.99z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m334.6 175.309 98.72 98.72-22.16 38.38-.58 1.01-25.38 43.95-119.48-119.48c-6.67-4.99-8.79-13.21-8.79-25.6v-35.72c0-6.85.26-11.42 2.51-15.88 5.38-10.64 15.41-13.93 28.52-13.93 11.45 0 21.36 1.28 27.29 9.2z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m463.17 222.329-29.85 51.7-22.16 38.38-.58 1.01-71-71c-2.88-1-2.98-2.87-2.98-5.59v-85.73c0-3.37 1.1-4.34 5.81-4.34h27.91c10.94 0 20.44 1.17 26.15 8.87z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m153.029 216.876c0-16.309-42.728-13.479-42.728-45.02 0-20.218 17.657-27.901 34.506-27.901 7.144 0 26.823 1.348 26.823 11.862 0 3.639-2.426 11.053-8.357 11.053-4.852 0-7.413-5.122-18.466-5.122-9.57 0-13.479 3.909-13.479 8.088 0 13.479 42.728 10.918 42.728 44.885 0 19.41-14.153 29.924-33.697 29.924-17.658 0-32.485-8.627-32.485-17.523 0-4.583 4.043-11.322 9.166-11.322 6.335 0 10.379 9.974 22.914 9.974 6.2-.002 13.075-2.428 13.075-8.898z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m242.8 144.764c4.448 0 6.335 4.852 6.335 9.301 0 5.122-2.292 9.57-6.335 9.57h-18.601v73.191c0 4.313-5.257 6.47-10.514 6.47s-10.514-2.157-10.514-6.47v-73.191h-18.6c-4.044 0-6.336-4.448-6.336-9.57 0-4.448 1.887-9.301 6.336-9.301z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m254.934 212.294v-35.719c0-23.184 14.422-31.81 33.023-31.81s33.158 8.627 33.158 31.81v35.719c0 23.184-14.557 31.81-33.158 31.81s-33.023-8.627-33.023-31.81zm45.154-35.72c0-9.301-4.583-13.479-12.131-13.479s-11.996 4.178-11.996 13.479v35.719c0 9.301 4.448 13.479 11.996 13.479 7.549 0 12.131-4.178 12.131-13.479z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m334.596 151.099c0-3.37 3.1-6.335 7.818-6.335h27.901c17.792 0 31.81 8.357 31.81 31.002v.674c0 22.645-14.557 31.271-33.158 31.271h-13.344v29.115c0 4.313-5.257 6.47-10.513 6.47-5.257 0-10.514-2.157-10.514-6.47zm21.028 11.996v28.441h13.344c7.549 0 12.131-4.313 12.131-13.479v-1.483c0-9.166-4.583-13.479-12.131-13.479z",
    fill: "url(#SVGID_11_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m108.279 328.768 25.037 43.366c5.882 10.188 16.752 16.464 28.516 16.464h186.336c11.764 0 22.634-6.276 28.516-16.464l25.037-43.366z",
    fill: "url(#SVGID_12_)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStopSign);
export default __webpack_public_path__ + "static/media/icon-stop-sign.ba96027a2fede7ac5b08f37d32ccf2f6.svg";
export { ForwardRef as ReactComponent };